import { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

export const requestSuccess = (request: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const username = process.env.DM_APPLICATION_CONFIG_BASIC_AUTH_USERNAME;
  const password = process.env.DM_APPLICATION_CONFIG_BASIC_AUTH_PASSWORD;

  if (!request.headers) {
    request.headers = new AxiosHeaders();
  }

  request.headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;

  return request;
};
